import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-count-controller',
  templateUrl: './count-controller.component.html',
  styleUrls: ['./count-controller.component.scss'],
  standalone: true
})
export class CountControllerComponent implements OnInit {
  @Input() value: number;
  @Input() index: number;
  @Output() changeCount: EventEmitter<{
    event: Event,
    index: number,
    step: number
  }> = new EventEmitter<{
    event: Event,
    index: number,
    step: number
  }>();

  constructor() {
  }

  ngOnInit(): void {
  }

}
